import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { getFormattedDate } from "@utils/CommonUtils";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DataTable } from "~/Components";
import { magpCMSApi } from "~/Services";
import { renderActionsColumn, renderDateColumn, renderPublishedColumn } from "~/Utils/TableRenderFunction";
import { useSourcingProcessFlowChart } from "../Manual.hook";
import { ProcurementPlanningProcessFlowChartProps } from "../ProcurementPlanning/ProcurementPlanningProcessFlowChart";
export const SourcingProcessFlowChart: React.FC<ProcurementPlanningProcessFlowChartProps> = ({ listId, toggleId }) => {
  const query = useQuery();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const firstQueryTab = query.get("activeTab");
  const secondQueryTab = query.get("subActiveTab");
  const thirdQueryTab = query.get("thirdChildActiveTab");

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  const id = searchParams.get("id");

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchData,
  } = useSourcingProcessFlowChart(selectedRowData?.id ?? null);

  useEffect(() => {
    if (selectedRowData?.id) {
      refetchData();
    }
  }, [selectedRowData?.id]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const url = `/api/get-sourcing-process-flow-chart/all-fields?listId=${listId}&toggleId=${toggleId}`;
      try {
        const res = await magpCMSApi.get(url);
        if (res && res.data) {
          setData(res.data);
        }
      } catch (err) {
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  // if (id && selectedRowData) {
  //   return <EditProcurementPlanningProcessFlowChart record={selectedRowData} />;
  // }

  const renderDate = (value: any) =>
    value ? (
      <Typography.Text>{getFormattedDate(value)}</Typography.Text>
    ) : (
      <Typography.Text className="text-gray-400">-</Typography.Text>
    );

  const renderPublishedStatus = (value: any) =>
    value ? (
      <Typography.Text>Published</Typography.Text>
    ) : (
      <Typography.Text className="text-gray-400">Unpublished</Typography.Text>
    );

  const renderActions = (record: any) => (
    <div className="flex gap-2.5">
      <Icon
        height={25}
        icon={"iconamoon:eye"}
        className="text-blue-600 border border-blue-600 rounded-full p-0.5"
        onClick={(e) => {
          e.preventDefault();
          setSelectedRowData(record);
          setDrawerVisible(true);
        }}
      />
      <Icon
        height={25}
        icon={"carbon:edit"}
        className="text-primary-color border border-primary-color rounded-full p-0.5 box-border"
        onClick={() => {
          navigate(
            `/dedicated/magp/manual/sourcing?activeTab=${query.get("activeTab")}&subActiveTab=${query.get(
              "subActiveTab"
            )}&thirdChildActiveTab=${query.get("thirdChildActiveTab")}&fourthChildActiveTab=${
              query.get("activeTab") + `ProcessFlowChart`
            }&editId=${record.id}`,
            { state: { record } }
          );
        }}
      />
    </div>
  );

  const columns: TableColumnsType = [
    {
      title: "Id",
      dataIndex: "seqNumber",
      key: "seqNumber",
      width: 60,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: renderDateColumn,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: renderDateColumn,
    },
    {
      title: "Published",
      dataIndex: "published",
      key: "published",
      width: 60,
      render: (value: string) => renderPublishedColumn(value),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record: any) =>
        renderActionsColumn(record, setSelectedRowData, setDrawerVisible, (e: any) => {
          e.preventDefault();
          navigate(
            `/dedicated/magp/manual/sourcing?activeTab=${firstQueryTab}&subActiveTab=${secondQueryTab}&thirdChildActiveTab=${thirdQueryTab}&fourthChildActiveTab=${firstQueryTab + `ProcessFlowChart`}&editId=${record.id}`,
            { state: { record } }
          );
        }),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        className="table-clickable"
        tableData={data}
        isLoading={isLoading}
        height={1000}
        exportFileName="CONTRACT"
        isPagination={false}
        multiSelect={false}
        hideExport={true}
        isServerSearchApi={false}
        searchPlaceholderText={"Search"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
      />
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "sourcingProcessFlowChart") as ModuleConfig]}
        data={drilldown?.[0]}
      />
    </>
  );
};
